export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///wAA//8AAOXl5SH5BAAAAAAALAAAAAASAAwAAAIknI95EO0BopSDNQvnrA7rfU3P2H0kqZ0qpjbCC8fyTNf2jc8FADs="